module.exports = __webpack_public_path__ + "img/MapsIcon.6fa83854.png";